(function () {
    if (window.chulaCardCarousel) return;
    window.chulaCardCarousel = true;

    function slidesOf(cc) {
      return cc.parentElement.querySelectorAll('.chula-cc__slide');
    }

    // Slides after the hover image arrive without sources (product-card.liquid)
    // and are given them the first time the card is engaged with.
    function hydrate(scope) {
      if (!scope) return;
      var pending = scope.querySelectorAll('img[data-cc-src]');
      for (var i = 0; i < pending.length; i++) {
        var img = pending[i];
        if (img.hasAttribute('data-cc-srcset')) {
          img.setAttribute('srcset', img.getAttribute('data-cc-srcset'));
          img.removeAttribute('data-cc-srcset');
        }
        img.setAttribute('src', img.getAttribute('data-cc-src'));
        img.removeAttribute('data-cc-src');
      }
    }

    function show(cc, index) {
      var count = parseInt(cc.getAttribute('data-cc-count'), 10) || 1;
      index = Math.max(0, Math.min(index, count - 1));
      cc.setAttribute('data-cc-index', index);

      var media = cc.parentElement.querySelector('.product-card__media');
      var primary = media ? media.querySelector('.product-card__image--primary') : null;

      if (primary) primary.style.opacity = index === 0 ? '1' : '0';

      var slides = slidesOf(cc);
      for (var i = 0; i < slides.length; i++) {
        slides[i].style.opacity = (i + 1 === index) ? '1' : '0';
      }

      var fill = cc.querySelector('.chula-cc__fill');
      if (fill) fill.style.transform = 'translateX(' + (index * 100) + '%)';

      var prev = cc.querySelector('[data-cc-prev]');
      var next = cc.querySelector('[data-cc-next]');
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === count - 1;
    }

    document.addEventListener('click', function (event) {
      if (!event.target.closest) return;
      var button = event.target.closest('[data-cc-prev], [data-cc-next]');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      var cc = button.closest('[data-chula-cc]');
      hydrate(cc.closest('.product-card'));
      var index = parseInt(cc.getAttribute('data-cc-index'), 10) || 0;
      show(cc, button.hasAttribute('data-cc-next') ? index + 1 : index - 1);
    });

    var startX = null;

    document.addEventListener('touchstart', function (event) {
      var figure = event.target.closest ? event.target.closest('.product-card__figure') : null;
      startX = figure && figure.querySelector('[data-chula-cc]') ? event.touches[0].clientX : null;
      if (startX !== null) hydrate(figure);
    }, { passive: true });

    document.addEventListener('touchend', function (event) {
      if (startX === null) return;
      var delta = event.changedTouches[0].clientX - startX;
      var figure = event.target.closest ? event.target.closest('.product-card__figure') : null;
      startX = null;
      if (!figure || Math.abs(delta) < 40) return;

      var cc = figure.querySelector('[data-chula-cc]');
      if (!cc) return;
      event.preventDefault();
      var index = parseInt(cc.getAttribute('data-cc-index'), 10) || 0;
      show(cc, delta < 0 ? index + 1 : index - 1);
    });

    // Louis Vuitton entrance: hovering the card fades straight to image 2.
    // From there arrows/swipe keep browsing — same fast crossfade throughout.
    document.addEventListener('mouseenter', function (event) {
      if (!event.target.closest) return;
      var card = event.target.closest('.product-card');
      if (!card) return;
      hydrate(card);
      var cc = card.querySelector('[data-chula-cc]');
      var count = cc ? parseInt(cc.getAttribute('data-cc-count'), 10) || 1 : 1;
      if (cc && count > 1 && cc.getAttribute('data-cc-index') === '0') show(cc, 1);
    }, true);

    // Reset when the pointer leaves, so cards do not stay mid-sequence.
    document.addEventListener('mouseleave', function (event) {
      if (!event.target.closest) return;
      var card = event.target.closest('.product-card');
      if (!card) return;
      var cc = card.querySelector('[data-chula-cc]');
      if (cc && cc.getAttribute('data-cc-index') !== '0') show(cc, 0);
    }, true);

    function init() {
      var all = document.querySelectorAll('[data-chula-cc]');
      for (var i = 0; i < all.length; i++) show(all[i], 0);
    }

    // Keyboard users reach the arrows by focus, not hover.
    document.addEventListener('focusin', function (event) {
      var card = event.target.closest ? event.target.closest('.product-card') : null;
      if (card) hydrate(card);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  // Fabric caption reflects whichever colour swatch is currently hovered or
  // focused, falling back to the card's default (first-available variant)
  // fabric once the pointer leaves. Swatch inputs carry data-variant-fabric
  // from custom.fabric on the variant — see option-value.liquid.
  (function () {
    if (window.chulaCardFabricSwatch) return;
    window.chulaCardFabricSwatch = true;

    function setFabric(card, value) {
      var el = card.querySelector('[data-chula-fabric-text]');
      if (el && value) el.textContent = value;
    }

    function resetFabric(card) {
      var wrap = card.querySelector('.product-card__type');
      if (wrap) setFabric(card, wrap.getAttribute('data-chula-fabric-default'));
    }

    function fabricFor(swatchLabel) {
      var input = swatchLabel.previousElementSibling;
      return input && input.getAttribute ? input.getAttribute('data-variant-fabric') : null;
    }

    document.addEventListener('pointerenter', function (event) {
      var label = event.target.closest ? event.target.closest('.color-swatch') : null;
      if (!label) return;
      var card = label.closest('.product-card');
      var fabric = fabricFor(label);
      if (card && fabric) setFabric(card, fabric);
    }, true);

    document.addEventListener('pointerleave', function (event) {
      var label = event.target.closest ? event.target.closest('.color-swatch') : null;
      if (!label) return;
      var card = label.closest('.product-card');
      if (card) resetFabric(card);
    }, true);

    document.addEventListener('focusin', function (event) {
      var label = event.target.closest ? event.target.closest('.color-swatch') : null;
      if (!label) return;
      var card = label.closest('.product-card');
      var fabric = fabricFor(label);
      if (card && fabric) setFabric(card, fabric);
    });

    document.addEventListener('focusout', function (event) {
      var label = event.target.closest ? event.target.closest('.color-swatch') : null;
      if (!label) return;
      var card = label.closest('.product-card');
      if (card) resetFabric(card);
    });
  })();

  /* Reveal cards as they arrive, not on a timer.
     Prestige reveals a whole <product-list> at once, and only once the list
     itself is in the viewport: 0.4s of nothing, then 0.05s a card, then a
     0.2s fade. On a long collection that leaves rows blank for up to a second
     after you have scrolled to them. Here each card is revealed on its own, a
     screen ahead of arriving, by REMOVING the attribute — which both drops the
     opacity: 0 rule (css-variables carries the fade it runs into) and takes
     the card out of Prestige's selector, so its animation never runs on top.
     Facet filtering replaces the grid wholesale, so new cards are picked up by
     a mutation observer rather than a one-off query. */
  (function () {
    if (window.chulaCardReveal) return;
    window.chulaCardReveal = true;

    var SELECTOR = 'product-card[reveal-on-scroll="true"], .product-list__promo[reveal-on-scroll="true"]';

    /* A card still approaching gets the fade. One that is ALREADY on screen
       when it is first seen — which is what a fast scroll or a jump produces —
       is shown at once: fading it there is the blank screen the fade was
       supposed to prevent. */
    function reveal(el, instant) {
      if (instant) {
        el.style.transition = 'none';
        el.removeAttribute('reveal-on-scroll');
        void el.offsetHeight;
        el.style.transition = '';
        return;
      }
      el.removeAttribute('reveal-on-scroll');
    }

    function start() {
      if (!('IntersectionObserver' in window)) {
        var all = document.querySelectorAll(SELECTOR);
        for (var i = 0; i < all.length; i++) reveal(all[i], true);
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          var box = entries[i].boundingClientRect;
          var onScreenAlready = box.top < window.innerHeight && box.bottom > 0;
          reveal(entries[i].target, onScreenAlready);
          io.unobserve(entries[i].target);
        }
      }, { rootMargin: '600px 0px 600px 0px' });

      function observeAll() {
        var pending = document.querySelectorAll(SELECTOR);
        for (var i = 0; i < pending.length; i++) io.observe(pending[i]);
      }

      observeAll();

      var queued = null;
      new MutationObserver(function () {
        if (queued) return;
        queued = setTimeout(function () { queued = null; observeAll(); }, 120);
      }).observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
